import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Row, Col, Spin, Typography, Collapse, Space, Card } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import { ROW_JUSTIFY, COL_SPAN, AvatarColorsArr } from '../common/const'
import {
  getRedirectUrl,
  OpenBrowserUrl,
  getTeamAvatarStr,
  addUrlParam,
  getUrlParam,
} from '../common/globalFun'
import {
  GetTeamList,
  PostTeamOpen,
  GetLoginStatus,
  PostTeamSwitch,
} from '../config/request'
import { useIntl } from 'react-intl'
import PageBg from '../components/PageBg'

import './css/style.css'

import iconArrowRight from '../res/img/arrow_right.png'
import iconActive from '../res/img/right.png'
import { useLayoutEffect } from 'react'

const { Title } = Typography
const { Panel } = Collapse

const TeamListSwitch = (props) => {
  const { history } = props
  const intl = useIntl()

  const [teamList, setTeamList] = useState([])
  const [isInit, setIsInit] = useState(false)
  const [listLoading, setListLoading] = useState(false)

  const [redirectUrl, setRedirectUrl] = useState('')

  const checkUrlParam = () => {
    getUrlParam('redirect_url').then((url) => {
      setRedirectUrl(decodeURIComponent(url))
    })
  }

  const translateTeamList = (data) => {
    if (!data || !data.length) {
      return []
    }
    data.forEach((teamGroup) => {
      const teamId = teamGroup.team_id
      const newTeams = []
      teamGroup.teams.map((team) => {
        team.avatarColor =
          AvatarColorsArr[team.team_id % AvatarColorsArr.length]
        if (team.team_id === teamId) {
          team.isSelected = true
          newTeams.unshift(team)
        } else {
          newTeams.push(team)
        }
      })
      teamGroup.teams = newTeams
    })
    data.reverse()
    return data
  }

  const getTeamList = () => {
    GetTeamList()
      .then((teams) => {
        const newTeams = translateTeamList(teams)
        if (!newTeams || !newTeams.length) {
          GetLoginStatus({ status_type: 'register' }).then((data) => {
            const { status, accountList } = data
            let nextPath = ''
            switch (Number(status)) {
              case 0:
                nextPath = '/login'
                break
              case 2:
                nextPath = '/signin_org'
                break
              default:
                break
            }
            props.setGlobalEmail(accountList[0])
            history.push(nextPath)
          })
          return
        }
        setTeamList(newTeams)
      })
      .finally(() => {
        setIsInit(true)
      })
  }

  const openTeam = (data) => {
    const { account, team } = data
    const { team_id, isSelected } = team

    if (isSelected) return

    setListLoading(true)

    PostTeamSwitch({ team_id })
      .then(() =>
        PostTeamOpen({
          account: account,
          teamIds: [team_id],
        })
      )
      .then(() => {
        if (redirectUrl) {
          const newUrl = addUrlParam(redirectUrl, { team_id: team_id })
          OpenBrowserUrl(newUrl)
        } else {
          window.history.go(-1)
        }
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        setListLoading(false)
      })
  }

  /**
   * 请求相关
   */

  useEffect(() => {
    getTeamList()
  }, [])

  useLayoutEffect(() => {
    checkUrlParam()
  }, [])

  /**
   * Dom
   */

  const loadingIcon = () => (
    <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
  )

  const TeamItemCard = (props) => {
    const { team } = props
    return (
      <Card
        hoverable={!team.isCurrent && !team.isSelected}
        size="small"
        onClick={() => {
          openTeam(props)
        }}
        className={`felo-card ${team.isSelected ? 'default' : ''}`}
      >
        <Row wrap={false} className="card-wrap">
          <Col flex="auto">
            <Row wrap={false}>
              <Col className="card-avatar-section">
                <div
                  className={`card-avatar-wrap ${
                    team.isCurrent ? 'active' : ''
                  }`}
                >
                  <div
                    className="card-avatar"
                    style={{
                      backgroundColor: team.avatarColor
                        ? team.avatarColor
                        : '#616061',
                    }}
                  >
                    {getTeamAvatarStr(team.team_name)}
                  </div>
                </div>
              </Col>
              <Col className="card-name">{team.team_name}</Col>
            </Row>
          </Col>
          <Col flex="none" className={`card-icon-wrap`}>
            {team.isSelected && (
              <span style={{ marginRight: 10, fontSize: 15 }}>
                {intl.formatMessage({ id: 'default' })}
              </span>
            )}
            {team.isCurrent ? (
              <img className="card-icon-active" src={iconActive} alt="" />
            ) : (
              <img className="card-icon-arrow" src={iconArrowRight} alt="" />
            )}
          </Col>
        </Row>
      </Card>
    )
  }

  return (
    <>
      <PageBg />
      <Row
        justify={ROW_JUSTIFY}
        align="middle"
        className={`height-full select-corp-page padding-vertical-50`}
      >
        <Col span={COL_SPAN}>
          <Spin
            spinning={listLoading}
            indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
          >
            <Space
              direction="vertical"
              size={15}
              className="mt-10 card-list-wrap"
            >
              {!!teamList.length &&
                (teamList.length === 1 ? (
                  <>
                    {teamList[0].teams.map((item, index) => {
                      return (
                        <TeamItemCard
                          key={index}
                          team={item}
                          account={teamList[0].account}
                        />
                      )
                    })}
                  </>
                ) : (
                  <>
                    <Collapse
                      defaultActiveKey={['0']}
                      className="team-list-collapse"
                    >
                      {teamList.map((team, index) => {
                        return (
                          <Panel
                            key={index}
                            header={
                              <div className="team-panel-wrap">
                                <Title
                                  className="panel-title"
                                  level={5}
                                  style={{ marginBottom: 0 }}
                                  title={team.account}
                                >
                                  {team.account}
                                </Title>
                              </div>
                            }
                          >
                            <div style={{ maxHeight: 500, overflow: 'auto' }}>
                              {team.teams.map((item, itemIndex) => {
                                return (
                                  <TeamItemCard
                                    key={itemIndex}
                                    team={item}
                                    account={team.account}
                                  />
                                )
                              })}
                            </div>
                          </Panel>
                        )
                      })}
                    </Collapse>
                  </>
                ))}

              {isInit && !teamList.length && (
                <section style={{ textAlign: 'center' }}>
                  <p>{intl.formatMessage({ id: 'not.org' })}</p>
                  <p>{props.email}</p>
                </section>
              )}
              {!isInit && <div className="content-center">{loadingIcon()}</div>}
            </Space>
          </Spin>
        </Col>
      </Row>
    </>
  )
}

const stateProps = (state) => {
  return {
    email: state.email,
  }
}

const dispatchProps = (dispatch) => ({
  setGlobalToken: (token) => {
    dispatch({
      type: 'setToken',
      value: token,
    })
  },
  setGlobalEmail: (email) => {
    dispatch({
      type: 'setEmail',
      value: email,
    })
  },
})

export default connect(stateProps, dispatchProps)(TeamListSwitch)
